export { default, Detached } from './ContactsTab';
